<template>
    <div class="main-content">
        <b-card no-body class="shadow-none bg-transparent">
            <date-picker></date-picker>
        </b-card>
        <card-loader v-if="loading" height="150px" class="mt-3"/>
        <score-participation-evolution-chart
            v-if="records.length"
            :dates="dates"
            :participation="participation"
            :title="title"
            class="mt-3"
        />
        <list
            :columns="columns"
            :rows="records"
            :select-options="{
                enabled: false,
            }"
            :pagination-options="{
                perPage: 20,
            }"
            :loading="loading"
            class="mt-3"
        />
    </div>
</template>

<script>
import api from '@/api/api'
import auth from '@/firebase/auth'

export default {
    name: 'ScoreEvolutionReport',
    components: {
        CardLoader: () => import('@/components/Loaders/CardLoader'),
        DatePicker: () => import('@/components/datePicker'),
        List: () => import('@/components/List/List'),
        ScoreParticipationEvolutionChart: () => import('@/components/Charts/ScoreParticipationEvolutionChart'),
    },
    data () {
        return {
            dates: [],
            loading: false,
            participation: [],
            records: [],
            score: [],
            emojis: [
                {
                    index: 3,
                    name: 'happy-1',
                    text: 'incrível',
                },
                {
                    index: 2,
                    name: 'happy',
                    text: 'feliz',
                },
                {
                    index: 1,
                    name: 'confused',
                    text: 'regular',
                },
                {
                    index: 0,
                    name: 'sad',
                    text: 'infeliz',
                },
            ],
            title: 'Evolução da Participação',
            columns: [
                {
                    label: 'Data e Hora',
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
                    dateOutputFormat: 'dd/MM/yyyy HH:mm',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Participação %',
                    field: 'percentage',
                    type: 'percentage',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Respondentes/Total',
                    field: 'responsesAndTotal',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
            ],
        }
    },
    methods: {
        loadData () {
            this.loading = true
            auth
                .currentUser
                .getIdToken()
                .then((token) => {
                    api
                        .get('/reports/participation-evolution', {
                            params: {
                                range: this.range,
                            },
                            headers: {
                                token,
                            },
                        })
                        .then(response => {
                            this.loading = false

                            if (!response.data || !response.data.length) return

                            response.data = response.data.filter(record => record.responses > 0)
                            this.dates = response.data.map(record => record.dateChart)
                            this.records = response.data.reverse()
                            this.participation = response.data.map(record => record.percentage * 100).reverse()
                        })
                })
                .catch(err => {
                    this.loading = false

                    console.log(err)
                })
        },
    },
    computed: {
        range () {
            return this.$store.getters['dashboard/range']
        },
    },
    watch: {
        range: {
            immediate: true,
            handler () {
                this.loadData()
            },
        },
    },
}
</script>
